import { apiClient } from "./apiClient";

const BASE_BOARDS = "/tasks/boards";

export async function listBoardsApi({ token, workspaceId }) {
    // Assuming apiClient handles token. We might need to pass workspaceId if backend requires it in query or header not handled by apiClient
    // Based on tasksService, we can pass it in query if needed.
    // Backend controller looks for req.query.workspaceId or header.
    return apiClient(`${BASE_BOARDS}?workspaceId=${workspaceId}`, {
        token,
        method: "GET",
    });
}

export async function createBoardApi({ token, workspaceId, data }) {
    return apiClient(`${BASE_BOARDS}?workspaceId=${workspaceId}`, {
        token,
        method: "POST",
        body: data
    });
}

export async function updateBoardApi({ token, workspaceId, boardId, data }) {
    return apiClient(`${BASE_BOARDS}/${boardId}`, {
        token,
        method: "PATCH",
        body: data
    });
}

export async function deleteBoardApi({ token, workspaceId, boardId }) {
    return apiClient(`${BASE_BOARDS}/${boardId}`, {
        token,
        method: "DELETE"
    });
}

export async function getBoardTasksApi({ token, workspaceId, boardId }) {
    return apiClient(`${BASE_BOARDS}/${boardId}/tasks?workspaceId=${workspaceId}`, {
        token,
        method: "GET"
    });
}

export async function getBoardStatusesApi({ token, workspaceId, boardId }) {
    return apiClient(`${BASE_BOARDS}/${boardId}/statuses?workspaceId=${workspaceId}`, {
        token,
        method: "GET"
    });
}
